module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAjAAAAFeAQMAAAChKbebAAAAA1BMVEUAzO/wgFpxAAAAL0lEQVR42u3BMQEAAADCIPuntsROYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALkDYRIAAYYuxxQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile@1x/bg/2.png
// module id = n8Ii
// module chunks = 0